/* eslint-disable react/prop-types */
import { Icon, Tooltip } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { formatMoneyPunto } from "utils/formatters";
import { makeNiceText } from "utils/formatters";

const getRows = (data, ejecutarAccion) => {
  const rows = [];
  if (data) {
    data.forEach((item) => {
      rows.push({
        nombre: (
          <SoftBox pl={2}>
            {item?.disabled ? (
              <Tooltip title="El producto se encuentra deshabilitado, deberá eliminarlo de la lista o reemplazarlo">
                <SoftTypography color="error" verticalAlign="text-top" variant="caption" fontWeight="bold">
                  {item?.nombre ? makeNiceText(item?.nombre) : "Sin nombre"}
                </SoftTypography>
              </Tooltip>
            ) : (
              <SoftTypography verticalAlign="text-top" variant="caption">
                {item?.nombre ? makeNiceText(item?.nombre) : "Sin nombre"}
              </SoftTypography>
            )}
          </SoftBox>
        ),
        precio: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item.precio
                ? `$${formatMoneyPunto(item.precio)} X ${item.tipoUnidadOrigen?.abreviatura}`
                : "Sin precio"}
            </SoftTypography>
          </SoftBox>
        ),
        costo: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item.precio
                ? `$${formatMoneyPunto(
                  item.precio *
                  (item.cantidad /
                    (item.tipoUnidadOrigen?.id !== item.tipoUnidad?.id
                      ? item.tipoUnidadOrigen?.multiplicador
                      : 1))
                )}`
                : "Sin costo"}
            </SoftTypography>
          </SoftBox>
        ),
        porcentajeUtilizable: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item.porcentajeUtilizable
                ? `${item.porcentajeUtilizable.toFixed(1)}%`
                : "Sin porcentaje"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidadUtilizable: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item?.cantidadUtilizable
                ? //Si cantidad utilizable es decimal, mostrarlo con 2 decimales
                item.cantidadUtilizable % 1 !== 0
                  ? item.cantidadUtilizable.toFixed(2)
                  : item.cantidadUtilizable
                : "Sin cantidad"}
              {" " + item.tipoUnidad?.abreviatura}
            </SoftTypography>
          </SoftBox>
        ),
        precioTotal: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item.precioUtilizable ? `$${formatMoneyPunto(item.precioUtilizable)}` : "Sin precio"}
            </SoftTypography>
          </SoftBox>
        ),
        cantidad: (
          <SoftBox>
            <SoftTypography verticalAlign="text-top" variant="caption">
              {item.cantidad + " " + item.tipoUnidad?.abreviatura}
            </SoftTypography>
          </SoftBox>
        ),
        accion: (
          <SoftBox
            mr={2}
            display="flex"
            flexDirection="row"
            justifyContent="flex-end"
            sx={{
              gap: 1,
            }}
          >
            <Tooltip title="Borrar" placement="top">
              <Icon
                fontSize="small"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  ejecutarAccion("borrar", item);
                }}
              >
                cancel
              </Icon>
            </Tooltip>
          </SoftBox>
        ),
      });
    });
  }

  return rows;
};

const columns = [
  { name: "nombre", desc: "Nombre", align: "left", noOrder: true },
  { name: "precio", desc: "Precio por unidad", align: "center", noOrder: true },
  { name: "costo", desc: "Costo", align: "center", noOrder: true },
  { name: "cantidad", desc: "Cantidad Neta", align: "center", noOrder: true },
  { name: "porcentajeUtilizable", desc: "Rendimiento", align: "center", noOrder: true },
  { name: "cantidadUtilizable", desc: "Cantidad Bruta necesaria", align: "center", noOrder: true },
  { name: "precioTotal", desc: "Precio Cant. Necesaria", align: "center", noOrder: true },
  { name: "accion", desc: " ", align: "center", width: "1%", noOrder: true },
];

const columns2 = [
  { name: "nombre", desc: "Nombre", align: "left", noOrder: true },
  { name: "cantidad", desc: "Cantidad Neta", align: "center", noOrder: true },
  { name: "porcentajeUtilizable", desc: "Rendimiento", align: "center", noOrder: true },
  { name: "cantidadUtilizable", desc: "Cantidad Bruta necesaria", align: "center", noOrder: true },
];

export default { columns, columns2, getRows };
